import React, { useContext } from 'react';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import SubHeader, {
	SubHeaderLeft,
	SubheaderSeparator,
} from '../../../layout/SubHeader/SubHeader';
import Page from '../../../layout/Page/Page';
import AuthContext from '../../../contexts/authContext';
import { demoPagesMenu } from '../../../menu';
import Announcement from '../../../components/management/announcement/Announcement';
import TodayFeeCollection from './dashboard-component/TodayFeeCollection';
import StudentFeeTransaction from './dashboard-component/StudentFeeTransaction';
import StaffActivity from './dashboard-component/StaffActivity';
import FeesCollection from './dashboard-component/FeesCollection';
import PendingFees from './dashboard-component/PendingFees';

const AccountantDashboard = () => {
	const { userData } = useContext(AuthContext);

	return (
		<PageWrapper title={demoPagesMenu.sales.subMenu.dashboard.text}>
			<SubHeader>
				<SubHeaderLeft>
					<span className='fs-5'>Today Overview </span>
					<SubheaderSeparator />
					<strong className='fs-5'>Hi, <span className='text-primary'>{`${userData.fullname}`}</span> !</strong>
				</SubHeaderLeft>
			</SubHeader>
			<Page container='fluid'>
				<div className='row'>
					<div className='col-xl-12'>
						<Announcement />
					</div>
					<div className='col-xl-12'>
						<TodayFeeCollection />
					</div>
					<div className='col-xl-6'>
						<StudentFeeTransaction />
					</div>
					<div className='col-xl-6'>
						<StaffActivity />
					</div>
					<div className='col-xl-6'>
						<FeesCollection />
					</div>
					<div className='col-xl-6'>
						<PendingFees />
					</div>
				</div>
			</Page>
		</PageWrapper>
	);
};

export default AccountantDashboard;
